<template>
  <div>
    <!-- User Info: Input Fields -->
    <b-form>
      <b-row>
        <b-col cols="12" class="d-flex mb-1">
          <feather-icon icon="UserIcon" size="19" />
          <h4 class="mb-0 ml-50">
            รายละเอียดสินค้า
          </h4>
        </b-col>
        <!-- Field: Username -->
                <b-col cols="12">
          <b-form-group label="ประเภทสินค้า" label-for="categoryName">
            <b-form-input id="categoryName" v-model="product.categoryName" disabled />
          </b-form-group>
        </b-col>

        <!-- <b-col cols="12">
          <b-form-group label="ประเภทสินค้า" label-for="user-status">
            <b-form-input id="username" disabled />
          </b-form-group>
        </b-col> -->

        <!-- Field: Status -->
        <!-- <b-col cols="12">
          <b-form-group label="Product Size" label-for="user-status">
            <b-form-input id="username" />
          </b-form-group>
        </b-col> -->

        <!-- Field: Status -->
        <!-- <b-col cols="12">
          <b-form-group label="Product Color" label-for="user-status">
            <b-form-input id="username" />
          </b-form-group>
        </b-col> -->

        <!-- Field: Status -->
        <!-- <b-col cols="12">
          <b-form-group label="More Options" label-for="user-status">
            <b-form-input id="username" />
          </b-form-group>
        </b-col> -->

        <!-- Field: Status -->
        <b-col cols="12">
          <b-form-group label="จำนวนสินค้าในสต๊อก" label-for="stockQuantity">
            <b-form-input
              id="stockQuantity"
              v-model="product.stockQuantity"
              disabled
            />
          </b-form-group>
        </b-col>

        <!-- Field: Status -->
        <b-col cols="12">
          <b-form-group label="สถานะการใช้งาน" label-for="user-status">
            <b-form-input
              id="username"
              :value="product.isPublished ? 'Active' : 'Inactive'"
              disabled
            />
          </b-form-group>
        </b-col>

        <!-- Field: Status -->
        <b-col cols="12">
          <b-form-group>
            <label for="textarea-default">หมายเหตุ</label>
            <b-form-textarea
              id="textarea-default"
              rows="3"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";
import useUsersList from "../products-list/useProductsList";
export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { resolveUserRoleVariant } = useUsersList();

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    const permissionsData = [
      {
        module: "Admin",
        read: true,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "Staff",
        read: false,
        write: true,
        create: false,
        delete: false,
      },
      {
        module: "Author",
        read: true,
        write: false,
        create: true,
        delete: false,
      },
      {
        module: "Contributor",
        read: false,
        write: false,
        create: false,
        delete: false,
      },
      {
        module: "User",
        read: false,
        write: false,
        create: false,
        delete: true,
      },
    ];

    const languageOptions = [
      "English",
      "Spanish",
      "French",
      "Russian",
      "German",
      "Arabic",
      "Sanskrit",
    ];

    const genderOptions = [
      { text: "ชาย", value: "male" },
      { text: "หญิง", value: "female" },
    ];

    const contactOptionsOptions = ["Email", "Message", "Phone"];

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        // eslint-disable-next-line no-param-reassign
        // props.userData.avatar = base64;
      }
    );

    return {
      resolveUserRoleVariant,
      avatarText,
      roleOptions,
      statusOptions,
      permissionsData,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      languageOptions,
      genderOptions,
      contactOptionsOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
